const fs = require('fs')
const path = require('path')

function Settings(filepath) {

    let options = null

    function readFile(filepath) {
        let rawFile = `{
            "name": {},
            "slack_webhook_url": {},
            "timecard":{
              "constants": {},
              "data": {}
            }
        }`

        // Read the file
        try {
            rawFile = fs.readFileSync(filepath)
        } catch (err) {
            if (err.code === 'ENOENT') {
                fs.writeFileSync(filepath, rawFile)
            } else {
                throw err
            }
        }

        // Turn the file into JSON
        try {
            options = JSON.parse(rawFile)
        } catch (err) {
            err.filepath = filepath
            throw err
        }

        return options

    }

	this.set = (key, value) => {
		options = options || readFile(filepath)
		options[key] = value
		fs.writeFileSync(filepath, JSON.stringify(options, null, 2))
		return this
	}

	this.get = key => {
		options = options || readFile(filepath)
		if (key in options) {
			return options[key]
		} else {
			return undefined
		}
	}

	this.unset = key => {
		options = options || readFile(filepath)
		delete options[key]
		fs.writeFileSync(filepath, JSON.stringify(options, null, 2))
	}

}

module.exports = {
    file: filename => {
        if (typeof filename !== 'string')
            throw new Error('invalid filename')

        const homedir = process.env.HOME
        const filepath = path.join(homedir, filename)

        return new Settings(filepath)
    }
}



// WEBPACK FOOTER //
// ./src/libraries/settings.js